var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "poll-title" }, [
      _vm._v(
        _vm._s(_vm._("Які продукти ви уже ввели в прикорм своєму малюку?"))
      )
    ]),
    _c("p", { staticClass: "poll-text poll-text--bold" }, [
      _vm._v(_vm._s(_vm._("Ви можете обрати декілька варіантів відповіді.")))
    ]),
    _c(
      "div",
      { staticClass: "poll-products" },
      _vm._l(_vm.products, function(item) {
        return _c(
          "div",
          {
            staticClass: "poll-products__el",
            class: { "is-disabled": item.is_disabled }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product,
                  expression: "product"
                }
              ],
              staticClass: "poll-products__input",
              attrs: {
                disabled: item.is_disabled,
                type: "checkbox",
                name: "products",
                id: item.key
              },
              domProps: {
                value: item.key,
                checked: Array.isArray(_vm.product)
                  ? _vm._i(_vm.product, item.key) > -1
                  : _vm.product
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.product,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = item.key,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.product = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.product = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.product = $$c
                    }
                  },
                  function($event) {
                    return _vm.check(item)
                  }
                ]
              }
            }),
            _c(
              "label",
              { staticClass: "poll-products__label", attrs: { for: item.key } },
              [
                _c("span", {
                  staticClass: "poll-products__icon",
                  class: ["svgicon-" + item.img]
                }),
                _c("p", { staticClass: "poll-products__text" }, [
                  _vm._v(" " + _vm._s(item.title) + " ")
                ])
              ]
            )
          ]
        )
      }),
      0
    ),
    _c(
      "button",
      {
        staticClass: "poll-btn",
        class: { "is-disabled": !_vm.product.length },
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.next($event)
          }
        }
      },
      [_vm._v(_vm._s(_vm._("Далі")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-269e9b20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269e9b20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/products.vue
// module id = 215
// module chunks = 4